import React, { useState, memo, useRef } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBarCollapse from "./AppBarCollapse";
import useMediaQuery from '@material-ui/core/useMediaQuery';


//const NavMenu2 = ({ isFilterOpen, setIsFilterOpen }) => {

//    const [isOpen, setIsOpen] = useState(false);
    //const drawerWidth = 240;

    //const useStyles = makeStyles((theme) => ({
    //    root: {
    //        display: 'flex',
    //    },
    //    appBar: {
    //        transition: theme.transitions.create(['margin', 'width'], {
    //            easing: theme.transitions.easing.sharp,
    //            duration: theme.transitions.duration.leavingScreen,
    //        }),
    //    },
    //    appBarShift: {
    //        width: `calc(100% - ${drawerWidth}px)`,
    //        marginLeft: drawerWidth,
    //        transition: theme.transitions.create(['margin', 'width'], {
    //            easing: theme.transitions.easing.easeOut,
    //            duration: theme.transitions.duration.enteringScreen,
    //        }),
    //    },
    //    menuButton: {
    //        marginRight: theme.spacing(2),
    //    },
    //    hide: {
    //        display: 'none',
    //    },
    //    drawer: {
    //        width: drawerWidth,
    //        flexShrink: 0,
    //    },
    //    drawerPaper: {
    //        width: drawerWidth,
    //    },
    //    drawerHeader: {
    //        display: 'flex',
    //        alignItems: 'center',
    //        padding: theme.spacing(0, 1),
    //        // necessary for content to be below app bar
    //        ...theme.mixins.toolbar,
    //        justifyContent: 'flex-end',
    //    },
    //    content: {
    //        flexGrow: 1,
    //        padding: theme.spacing(3),
    //        transition: theme.transitions.create('margin', {
    //            easing: theme.transitions.easing.sharp,
    //            duration: theme.transitions.duration.leavingScreen,
    //        }),
    //        marginLeft: -drawerWidth,
    //    }
    //}));

    //const classes = useStyles();
    //console.log("MMM");
    //console.log(isFilterOpen);
    //{/*<AppBar*/ }
    //{/*    position="fixed"*/ }
    //{/*    className={clsx(classes.appBar, {*/ }
    //{/*        [classes.appBarShift]: isFilterOpen,*/ }
    //{/*    })}*/ }
    //{/*>*/ }
    //{/*    <Toolbar>*/ }
    //{/*        <IconButton*/ }
    //{/*            color="inherit"*/ }
    //{/*            aria-label="open drawer"*/ }
    //{/*            onClick={() => setIsFilterOpen(true)}*/ }
    //{/*            edge="start"*/ }
    //{/*            className={clsx(classes.menuButton, isFilterOpen && classes.hide)}*/ }
    //{/*        >*/ }
    //{/*            <MenuIcon />*/ }
    //{/*        </IconButton>*/ }
    //{/*        <Typography variant="h6" noWrap>*/ }
    //{/*            Persistent drawer*/ }
    //{/*        </Typography>*/ }
    //{/*    </Toolbar>*/ }
    //{/*</AppBar>*/ }

//    var alternate = (
//        <AppBar position="static">
//            <Toolbar>
//                <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
//                    <MenuIcon />
//                </IconButton>
//                <Typography variant="h6" className={classes.title}>
//                    News
//                </Typography>
//                <Button color="inherit">Login</Button>
//            </Toolbar>
//        </AppBar>
//    )

//    var main = (
//        <header style={{ backgroundColor: "rgba(35, 55, 75, 0.9)" }}>
//            <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow" dark>
//                <Container>
//                    <NavbarBrand tag={Link} to="/">HouseMi Pre-Alpha</NavbarBrand>
//                    <NavbarToggler onClick={() => setIsOpen(a => !a)} className="mr-2" />
//                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={isOpen} navbar>
//                        <ul className="navbar-nav flex-grow">
//                            <NavItem>
//                                <NavLink tag={Link} className="text-light" to="/">Home</NavLink>
//                            </NavItem>
//                            <NavItem>
//                                <NavLink tag={Link} className="text-light" to="/about">About</NavLink>
//                            </NavItem>
//                        </ul>
//                    </Collapse>
//                </Container>
//            </Navbar>
//        </header>
//    );

//    return main;
//}

//export default memo(NavMenu);
//const narrow = useMediaQuery("max-device-height:400");

//const styles = {
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    navigation: {},
    toggleDrawer: {},
    appTitle: {},
    toolBar: {
        minHeight: 48,
        ['@media (max-height:' + theme.breakpoints.values.phone + 'px)']: {
            minHeight: 32,
        },
        ['@media (min-height' + theme.breakpoints.values.phone + 'px)']: {
            minHeight: 48, //don't this does anything...
        }
    }
}));

const NavMenu = (props) => {
    const classes = useStyles();
    //const { classes } = props;
    return (
        <div style={{ position: "relative", WebkitTransform: "translate3d(0,0,0)" }}>
            <AppBar position="fixed" className={classes.navigation}>
                <Toolbar className={classes.toolBar} >
                    <Typography
                        color="inherit"
                        className={classes.appTitle}
                    >
                        MOVEista (Alpha)
                    </Typography>
                    <AppBarCollapse />
                </Toolbar>
            </AppBar>
            <Toolbar className={classes.toolBar} />
        </div>
    );
}


export default NavMenu;